import { render } from "./DesktopTerms.vue?vue&type=template&id=87803c0c&scoped=true"
import script from "./DesktopTerms.vue?vue&type=script&scoped=true&lang=js"
export * from "./DesktopTerms.vue?vue&type=script&scoped=true&lang=js"

import "../../../../assets/css/agreement.css?vue&type=style&index=0&id=87803c0c&scoped=true&lang=css"
import "./DesktopTerms.vue?vue&type=style&index=1&id=87803c0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87803c0c"

export default script